<template>
  <el-row class="tac">
    <el-col :span="2.5">
      <h5>[导航]</h5>
      <el-menu
        default-active="Index"
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        :collapse="true"
        :router="false"
      >
        <el-menu-item index="Index" @click="$router.push({name:'Index'}).catch(()=>{})">
          <i class="el-icon-data-line"></i>
          <span slot="title">生长发育</span>
        </el-menu-item>
        <el-menu-item index="HelloWorld" @click="$router.push({name:'HelloWorld'}).catch(()=>{})">
          <i class="el-icon-mobile"></i>
          <span slot="title">计算器</span>
        </el-menu-item>
      </el-menu>
    </el-col>
  </el-row>
</template>
<script>
export default {
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue